<template>
  <TrustList class="md:my-40" data-qa="product-reassurance" />
</template>

<script setup lang="ts">
import TrustList from '~/scopes/reassurance/components/TrustList/TrustList.vue'
</script>
